
















import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"
import store from "@/store"

@Component({
  computed: {
    ...mapState("Auth", {
      roles: "roles",
      activeRoleKey: "activeRoleKey",
    }),
  },
})
export default class Dashboard extends Vue {
  beforeRouteEnter(to, from, next) {
    next(() => {
      const activeRoleKey = store.state["Auth"].activeRoleKey
      if (activeRoleKey !== "rNoActiveRole") {
        let role = store.getters["Auth/userRole"]
        role = role.toLowerCase()
        next({ name: role + "-dashboard", replace: true })
      }
    })
  }

  switchRole(role, roleKey) {
    this.$store.commit("Auth/SET_ACTIVE_ROLE", roleKey)

    if (roleKey === "rBusiness") {
      this.$store.commit("Auth/SET_ACTIVE_BUSINESS")
    }

    const query = { ...this.$route.query }
    const roleName = role.toLowerCase()
    this.$router.replace({
      name: roleName + "-dashboard",
      query,
      params: { role: roleName },
    })
  }
}
